<div class="modal-header">
  <h4 class="modal-title" translate>{{ discountCode?.code ? 'DISCOUNT_CODE_EDIT' : 'DISCOUNT_CODE_CREATE' }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <nav ngbNav #nav="ngbNav" class="nav-tabs">
    <ng-container ngbNavItem>
      <a ngbNavLink>FIELDS</a>
      <ng-template ngbNavContent>
        <form [formGroup]="submitForm">
          <!-- FIELDS -->
          <div class="row">
            <div class="col-12">
              <lib-gung-text-input [gungTranslate]="'CODE'" formControlName="code"></lib-gung-text-input>
              <div
                *ngIf="
                  submitForm.get('code').invalid &&
                  (submitForm.get('code').dirty || submitForm.get('code').touched)
                "
                class="alert alert-danger p-1"
              >
                <span translate>FORM_ERROR_REQUIRED</span>
              </div>
            </div>
          </div>
          <!-- <div class="row" *ngIf="!!discountCode?.code">
                    <div class="col-12">
                      <lib-gung-text-input [renderStatic]="!!discountCode?.code" [gungTranslate]="'CREATED_DATE'" [value]="submitForm.get('createdDate').value | date"></lib-gung-text-input>
                    </div>
                  </div> -->
          <div class="row" *ngIf="!!discountCode?.code">
            <div class="col-12">
              <div class="form-group">
                <label for="description" class="control-label" translate>CREATED_DATE</label>
                <input
                  class="form-control-plaintext"
                  type="text"
                  disabled
                  value="{{ submitForm.get('createdDate').value | date: dateUtilService.dateFormat }}"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="description" class="control-label" translate>DESCRIPTION</label>
                <textarea
                  class="form-control"
                  type="text"
                  name="description"
                  id="description"
                  formControlName="description"
                  rows="5"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="w-100" for="WRITE_EXPRESSION" translate>DISCOUNT_APPLICATION</label>
                <select
                  class="form-control"
                  #writeExpression
                  id="WRITE_EXPRESSION"
                  name="WRITE_EXPRESSION"
                  formControlName="writeExpression"
                  (change)="writeExpressionChange(writeExpression.value)"
                >
                  <option *ngFor="let expression of writeExpressions" [value]="expression.expression" translate>
                    {{ expression.description }}
                  </option>
                </select>
                <div
                  *ngIf="
                    submitForm.get('writeExpression').invalid &&
                    (submitForm.get('writeExpression').dirty || submitForm.get('writeExpression').touched)
                  "
                  class="alert alert-danger p-1"
                >
                  <span translate>FORM_ERROR_REQUIRED</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="w-100" for="maxMultipleUses" translate>MAX_MULTIPLE_USES</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  id="maxMultipleUses"
                  formControlName="maxMultipleUses"
                />
                <div
                  *ngIf="
                    submitForm.get('maxMultipleUses').invalid &&
                    (submitForm.get('maxMultipleUses').dirty || submitForm.get('maxMultipleUses').touched)
                  "
                  class="alert alert-danger p-1"
                >
                  <span translate>FORM_ERROR_REQUIRED</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="w-100" for="meeting-time" translate>VALID_FROM</label>
                <input
                  class="form-control"
                  type="datetime-local"
                  id="meeting-time"
                  #validFrom
                  name="meeting-time"
                  min="{{ minDate.toISOString().slice(0, -8) }}"
                  formControlName="validFrom"
                />
                <div
                  *ngIf="
                    submitForm.get('validFrom').invalid &&
                    (submitForm.get('validFrom').dirty || submitForm.get('validFrom').touched)
                  "
                  class="alert alert-danger p-1"
                >
                  <span translate>FORM_ERROR_REQUIRED</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="w-100" for="meeting-time" translate>VALID_UNTIL</label>
                <input
                  class="form-control"
                  type="datetime-local"
                  id="meeting-time"
                  name="meeting-time"
                  min="{{ minDate.toISOString().slice(0, -8) }}"
                  formControlName="validUntil"
                />
                <div
                  *ngIf="
                    submitForm.get('validUntil').invalid &&
                    (submitForm.get('validUntil').dirty || submitForm.get('validUntil').touched)
                  "
                  class="alert alert-danger p-1"
                >
                  <span translate>FORM_ERROR_REQUIRED</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="w-100" for="discountAmount" translate>DISCOUNT_AMOUNT</label>
                <input
                  class="form-control"
                  type="number"
                  min="0"
                  id="discountAmount"
                  formControlName="discountAmount"
                />
                <div
                  *ngIf="
                    submitForm.get('discountAmount').invalid &&
                    (submitForm.get('discountAmount').dirty || submitForm.get('discountAmount').touched)
                  "
                  class="alert alert-danger p-1"
                >
                  <span translate>FORM_ERROR_REQUIRED</span>
                </div>
              </div>
            </div>
          </div>

          @if (!!activeWriteExpression?.addsNewRow) {
            <div class="row">
              <div class="col-12">
                <lib-gung-checkbox-input-horizontal gungTranslate="ADDS_NEW_ROW" formControlName="addsNewRow">
                </lib-gung-checkbox-input-horizontal>
              </div>
            </div>
            <div class="row" *ngIf="submitForm.get('productId')">
              <div class="col-12">
                <div class="form-group">
                  <lib-gung-text-input [gungTranslate]="'PRODUCT_ID'" formControlName="productId"></lib-gung-text-input>
                  <div
                    *ngIf="
                      submitForm.get('productId').invalid &&
                      (submitForm.get('productId').dirty || submitForm.get('productId').touched)
                    "
                    class="alert alert-danger p-1"
                  >
                    <span translate>FORM_ERROR_REQUIRED</span>
                  </div>
                </div>
              </div>
            </div>
          }
          @if (!!activeWriteExpression?.orderRowDiscount) {
            <div class="row">
              <div class="col-12 mb-2" formGroupName="discountCodeConditions">
                <h5 translate>PRODUCT_CONDITIONS_DISCOUNT</h5>
                <div class="row">
                  <div class="col-12">
                    <lib-gung-select-option-input-horizontal
                      class="text-md-right"
                      gungTranslate="MATCHING"
                      [optionsList]="matchingOptionsList"
                      formControlName="logicalOperator"
                      [showId]="false"
                    ></lib-gung-select-option-input-horizontal>
                  </div>
                </div>
                <button class="btn btn-primary w-100 mt-2 mb-3" (click)="addLogicalCondition()" translate>
                  ADD_CONDITION
                </button>

                <div formArrayName="logicalConditions">
                  <div
                    *ngFor="let logicalCondition of logicalConditions?.controls; let i = index"
                    formGroupName="{{ i }}"
                    class="row"
                  >
                    <hr />
                    <div class="col-12">
                      <lib-gung-select-option-input-horizontal
                        class="text-md-right"
                        gungTranslate="SELECT_CONDITION"
                        [optionsList]="logicalConditionsOptionsList"
                        formControlName="expressionString"
                        [showId]="false"
                      ></lib-gung-select-option-input-horizontal>
                    </div>

                    <div class="col-12">
                      <lib-gung-text-input-horizontal
                        class="text-md-right"
                        [gungTranslate]="'DESCRIPTION'"
                        formControlName="conditionName"
                      ></lib-gung-text-input-horizontal>
                    </div>

                    <div class="col-12">
                      <lib-gung-text-area-input-horizontal
                        class="text-md-right"
                        [gungTranslate]="'ADD_VALUES'"
                        [tooltip]="'ADD_MULTIPLE_VALUES_AT_ONCE'"
                        (input)="onInputChange($event.target.value, i)"
                        [rowsNumber]="3"
                        placeholder="Value 1,value 2,value 3..."
                      ></lib-gung-text-area-input-horizontal>
                    </div>

                    <div class="col-12 col-md-8 offset-md-4">
                      <button class="btn btn-primary w-100 mb-3" (click)="addMultipleValues(i)" translate>
                        {{ 'ADD' | translate }}
                      </button>
                    </div>

                    <div class="col-12 col-md-4 text-md-right">{{ 'VALUES' | translate }}</div>
                    <div class="col-12 col-md-8 mb-3">
                      <button class="btn btn-danger mb-3" (click)="clearValues(i)">
                        {{ 'CLEAR_VALUES' | translate }}
                      </button>
                      <div class="row" formArrayName="expressionValues">
                        <div
                          *ngFor="
                            let control of logicalCondition.get('expressionValues').controls;
                            let valueIndex = index
                          "
                          class="input-group col-6 col-lg-4 mb-2"
                        >
                          <input type="text" class="form-control" [formControlName]="valueIndex" />
                          <div class="input-group-append">
                            <button class="btn btn-danger" type="button" (click)="clearSingleValue(i, valueIndex)">
                              <i class="fa-solid fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 col-md-4 text-md-right">
                      <a style="font-size: 60%" (click)="showExpression = !showExpression">{{showExpression ? 'HIDE_ADVANCED' : 'SHOW_ADVANCED' | translate}}</a>
                    </div>
                    @if(showExpression) {
                      <div class="col-12">
                        <lib-gung-text-area-input-horizontal
                          class="text-md-right"
                          [gungTranslate]="'EXPRESSION'"
                          formControlName="expressionString"
                          [rowsNumber]="3"
                        ></lib-gung-text-area-input-horizontal>
                      </div>
                    }

                    <div class="col-12 col-md-4 offset-md-8">
                      <button class="btn btn-danger w-100 mb-3" (click)="removeCondition(i)" translate>
                        REMOVE_CONDITION
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        </form>
      </ng-template>
    </ng-container>
    <ng-container ngbNavItem *ngIf="isActuator">
      <a ngbNavLink>MONGO</a>
      <ng-template ngbNavContent>
        <!-- MONGO OBJECT -->
        <textarea
          class="w-100"
          rows="15"
          [ngModel]="discountCodeMongo | json"
          [ngModelOptions]="{ updateOn: 'blur' }"
          (ngModelChange)="saveMongoObject($event)"
        ></textarea>
      </ng-template>
    </ng-container>
  </nav>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close('Cance click')" translate>CANCEL</button>
  <button type="button" class="btn btn-primary" [disabled]="disabled ? true : null" (click)="onSave()" translate>
    SAVE
  </button>
</div>
